import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

import * as Sentry from '@sentry/angular';
import { environment } from './environments/environment';

(window as any).smartlookEnabled = environment.smartlookEnabled;

Sentry.init({
    dsn: 'https://477e59cc685c715ff44c4b0075dbb733@o4507774493523968.ingest.de.sentry.io/4509480001405008',
    enabled: environment.production,
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({ maskAllText: false, blockAllMedia: false }),
    ],
    environment: environment.production ? 'production' : 'development',
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    // tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

bootstrapApplication(AppComponent, appConfig).catch(error => {
    Sentry.captureException(error, {
        extra: {
            message: 'Failed to bootstrap application',
        }
    });
});
